<template>
    <div class="right-content">

        <div class="title-block">
            <div class="title-left">{{$t('message.couponList.myCouponTitle')}}</div>
            <div class="title-right">
                {{$t('message.couponList.myScore')}}：{{getIntegral}}
                <m-icons type="integral1" size="16" color="#1293f5"/>
            </div>
        </div>
        <div class="coupon-list">

            <div v-if="availableCouponList.length === 0">

            </div>
            <div v-else v-for="coupon in availableCouponList" :key="coupon.mc_id" class="coupon stamp-bottom">
                <Icon type="md-pricetag" size="30" color="#0d6fb8"/>
                <div class="coupon-body">
                    <div class="coupon-name">{{coupon.name}}</div>
                    <div class="coupon-desc">{{$t('message.couponList.myCouponDes')}}</div>
                </div>
                <div class="col-dash-line"/>
                <div class="coupon-button">
                    <Button type="primary" @click="handleUse(coupon)"><span class="coupon-button-text">{{$t('message.couponList.buttonText')}}</span></Button>
                </div>
            </div>

        </div>

        <div class="line line-wrapper"></div>

        <div class="title-block">
            <div class="title-left">{{$t('message.couponList.redeemableCouponTitle')}}</div>
        </div>
        <div class="coupon-list">

            <div v-for="(coupon, index) in redeemableCouponList" :key="coupon.id" class="coupon stamp-bottom">
                <Icon type="md-pricetag" size="30" color="#0d6fb8"/>
                <div class="coupon-body">
                    <div class="coupon-name">{{coupon.name}}</div>
                    <div class="coupon-desc">{{coupon.integral}}{{$t('message.couponList.redeemableCouponDes')}}</div>
                </div>
                <div class="col-dash-line"/>
                <div class="coupon-button">
                    <Button type="primary" @click="showRedeemModal(index)"><span class="coupon-button-text">{{$t('message.couponList.redeemButton')}}</span>
                    </Button>
                </div>
            </div>

        </div>

        <!--        兑换优惠券对话框 start-->
        <Modal v-model="isShowRedeemModal" @on-ok="redeemCoupon">
            <p slot="header">{{$t('message.couponList.redeemModalTitle')}}</p>
            <p class="redeemModalText">{{redeemModalText}}</p>
        </Modal>
        <!--        兑换优惠券对话框 end-->

    </div>
</template>

<script>
  import {mapMutations, mapState} from "vuex";
  import {empty, getLocalLang, gotoPage, urlRequest} from "../../common/common";
  import mIcons from '@/components/m-icons/m-icons.vue';

  export default {
    name: "Coupon",

    data() {
      return {
        // 房间类型
        roomType: 0,
        // 是否展示优惠券对兑对话框
        isShowRedeemModal: false,
        // 选中的可兑换优惠券下标
        selectedCouponIndex: 0,
        // 可用优惠券列表
        availableCouponList: [],
        // 可兑换优惠券列表
        redeemableCouponList: [{integral: 0, name: ''}],
      }
    },

    props: {
      // 是否在对话框中显示
      isChooseCoupon: Boolean,
      // 处理使用优惠券方法
      handleUseCoupon: Function,
      // 房间类型
      roomTypeProp: Number,
    },

    created() {

      console.log('coupon roomType: ', this.roomType);
      console.log('roomTypeProp: ', this.roomTypeProp);

      this.roomType = this.roomTypeProp;
      this.loadData();

    },

    methods: {

      ...mapMutations([
        // 保存用户信息
        'setUserInfo',
      ]),

      // 处理使用优惠券
      handleUse(coupon) {
        if (this.isChooseCoupon) {
          localStorage.setItem('coupon', JSON.stringify(coupon));
        }
        this.handleUseCoupon();
      },

      // 积分兑换优惠券
      redeemCoupon() {
        urlRequest({
          url: this.api.redeemCoupon,
          method: 'POST',
          data: {
            'id': this.redeemableCouponList[this.selectedCouponIndex].id,
          }
        }).then(res => {
          // 兑换成功后更新用户信息和可用优惠券数据
          this.loadData();
          urlRequest({
            url: this.api.me,
            method: 'GET',
          }).then(res => {
            let userInfo = res.data.msg.user;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            this.setUserInfo(userInfo);
          });
        });
      },

      // 展示优惠券兑换对话框
      showRedeemModal(couponIndex) {
        this.isShowRedeemModal = true;
        this.selectedCouponIndex = couponIndex;
      },

      // 加载数据
      loadData() {
        // 获取我的优惠券数据
        urlRequest({
          url: this.api.getAvailableCouponList,
          method: 'POST',
          data: {
            'room_type': this.roomType,
          }
        }).then(res => {
          // 筛选掉可兑换物品券
          this.availableCouponList = res.data.msg.filter(item => {
            return item.room_type !== 0;
          });
        });

        // 获取可兑换优惠券数据
        urlRequest({
          url: this.api.getRedeemableCouponList,
          method: 'POST',
        }).then(res => {
          this.redeemableCouponList = res.data.msg.filter(item => {
            return item.room_type !== 0;
          });
        });
      },

    },

    computed: {

      ...mapState([
        // 用户信息
        'userInfo',
        // 是否登录
        'isLogin',
      ]),

      // 积分兑换对话框国际化文本
      redeemModalText() {
        let lang = getLocalLang();
        let score = this.redeemableCouponList[this.selectedCouponIndex].integral;
        let couponName = this.redeemableCouponList[this.selectedCouponIndex].name;
        if (lang === 'en') {
          return `Do you want to use ${score} scores to redeem ${couponName}?`;
        } else {
          return `是否用${score}积分兑换${couponName}？`;
        }
      },

      // 获取积分
      getIntegral() {
        if (this.isLogin) {
          return this.userInfo.integral;
        } else {
          return 0;
        }
      }

    },

    components: {
      mIcons,
    }
  }
</script>

<style lang="scss" scoped>
    @import "@/assets/style/mainStyle.scss";
    @import "Coupon.scss";

</style>
